import { useIntl } from 'react-intl'
import { NavLink } from 'react-router'
import { useAppSelector } from 'universal-scripts'
import { navItems, type NavItem } from './nav.config'

import './Nav.css'

export default function Nav() {
  const intl = useIntl()
  const isSidebarOpen = useAppSelector((state) => state.ui.isSidebarOpen)

  return (
    <nav id="main-nav" className={isSidebarOpen ? 'nav-extended' : ''}>
      <ul>
        {navItems.map((item: NavItem) => {
          const title = intl.formatMessage({ id: item.titleId })
          return (
            <li key={item.path}>
              <NavLink
                title={title}
                to={item.path}
                end={item.path === '/'}
                className={({ isActive }) =>
                  `nav-link${isActive ? ' active' : ''}`
                }
              >
                <span className={`icon icon-${item.icon}`} />
                <strong>{title}</strong>
              </NavLink>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
